
const LIMIT = 8
export default {
  name: 'PagesMarketplaceCommunity',
  props: {
    community: {
      type: Object,
      default: null,
    },
    contentType: {
      type: String,
      default: 'events',
    },
  },

  data() {
    return {
      posts: [],
      postsCount: 0,
      postsOffset: 0,
      currentStream: null,
      isNavFits: true,
      isVisibleAllCollections: false,
      isFetch: false,
    }
  },
  computed: {
    isHasProducts() {
      if (this.contentType === 'events') {
        return this.community.countAllPublishedEvents > 0
      } else if (this.contentType === 'offers') {
        return this.community.countAllPublishedOffers > 0
      } else {
        return (
          this.community.countAllPublishedEvents +
            this.community.countAllPublishedOffers >
          0
        )
      }
    },
    communityStreams() {
      this.setIsNavFits()
      if (this.community?.collection?.streams?.length) {
        const streams = JSON.parse(
          JSON.stringify(this.community.collection.streams)
        )
        if (this.contentType === 'events') {
          return streams
            .filter((stream) => stream.statistics.events.publishedCount > 0)
            .sort(
              (stream1, stream2) =>
                Number(this.isInSubscription(stream2._id)) -
                Number(this.isInSubscription(stream1._id))
            )
        } else if (this.contentType === 'offers') {
          return streams
            .filter((stream) => stream.statistics.products.publishedCount > 0)
            .sort(
              (stream1, stream2) =>
                Number(this.isInSubscription(stream2._id)) -
                Number(this.isInSubscription(stream1._id))
            )
        } else {
          return []
        }
      } else {
        return []
      }
    },
  },

  methods: {
    async inView({ isInView }) {
      if (isInView && !this.isFetch) {
        await this.fetchData()
        this.isFetch = true
      }
    },

    async fetchData() {
      if (this.currentStream) {
        await this.fetchByStream()
      } else if (this.contentType === 'events') {
        await this.fetchEvents()
      } else if (this.contentType === 'offers') {
        await this.fetchOffers()
      }
    },
    isInSubscription(id) {
      if (this.$auth.loggedIn) {
        return !!this.$auth.user.subscriptions?.streams?.find(
          (subscription) => {
            return subscription.stream === id
          }
        )
      } else {
        return false
      }
    },
    setIsNavFits() {
      if (process.client) {
        this.$nextTick(() => {
          const navList = this.$refs.navList
          const navWrap = this.$refs.navWrap
          this.isNavFits = navList?.scrollWidth <= navWrap?.clientWidth
        })
      }
    },

    async fetchEvents() {
      const streamsIds = this.community?.collection?.streams?.map(
        (stream) => stream._id
      )
      const { events, countAllPublishedEvents } = await this.$axios.$get(
        '/advertisements/streams/events',
        {
          params: {
            streams: streamsIds,
            limit: LIMIT,
            offset: this.postsOffset,
          },
        }
      )

      this.posts = this.posts?.length ? this.posts.concat(events) : events
      this.postsCount = countAllPublishedEvents
    },

    async fetchOffers() {
      const streamsIds = this.community?.collection?.streams?.map(
        (stream) => stream._id
      )
      const { offers, countAllPublishedOffers } = await this.$axios.$get(
        '/advertisements/streams/offers',
        {
          params: {
            streams: streamsIds,
            limit: LIMIT,
            offset: this.postsOffset,
          },
        }
      )

      this.posts = this.posts?.length ? this.posts.concat(offers) : offers
      this.postsCount = countAllPublishedOffers
    },

    async fetchByStream(stream = this.currentStream) {
      if (this.contentType === 'events') {
        const { events, countAllPublishedEvents } = await this.$axios.$get(
          `/advertisements/stream/events/${stream}`,
          {
            params: {
              limit: LIMIT,
              offset: this.postsOffset,
            },
          }
        )

        this.posts = this.posts?.length ? this.posts.concat(events) : events
        this.postsCount = countAllPublishedEvents
      } else if (this.contentType === 'offers') {
        const { offers, countAllPublishedOffers } = await this.$axios.$get(
          `/advertisements/stream/offers/${stream}`,
          {
            params: {
              limit: LIMIT,
              offset: this.postsOffset,
            },
          }
        )

        this.posts = this.posts?.length ? this.posts.concat(offers) : offers
        this.postsCount = countAllPublishedOffers
      }
    },
    loadMore() {
      this.postsOffset = this.postsOffset + LIMIT
      this.fetchData()
    },
    async setStream(streamUrl) {
      this.currentStream = streamUrl
      this.posts = []
      this.postsCount = 0
      this.postsOffset = 0
      if (this.currentStream) {
        await this.fetchByStream(streamUrl)
      } else {
        this.fetchData()
      }
    },
    updateSettings() {
      this.posts = []
      this.postsCount = 0
      this.postsOffset = 0
      this.fetchData()
    },
  },
}
